/**
 * MUI theme
 *
 * Brand colors were extracted from the provided Cyberlope logo.
 * - Primary teal: #06B2CF
 * - Brand gray:   #778D93
 *
 * Adjust as needed once you formalize a design system.
 */

import { createTheme } from "@mui/material/styles";
import traLogoUrl from "./assets/tra-logo.svg";
import trailBackgroundUrl from "./assets/trail-background.png";

// Extracted from the provided Cyberlope logo:
// Primary teal: #06B2CF
// Brand gray:   #778D93
export type ThemeMode = "light" | "dark";

export const createAppTheme = (mode: ThemeMode) =>
  createTheme({
    palette: {
      mode,
      primary: { main: "#06B2CF" },
      secondary: { main: "#778D93" },
      background:
        mode === "dark"
          ? { default: "#0B1114", paper: "#121A1E" }
          : { default: "#ffffff" },
    },
    shape: { borderRadius: 10 },
    typography: {
      fontFamily: [
        "Inter",
        "system-ui",
        "-apple-system",
        "Segoe UI",
        "Roboto",
        "Helvetica",
        "Arial",
        "sans-serif",
      ].join(","),
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            minHeight: "100vh",
            background:
              mode === "dark"
                ? `linear-gradient(rgba(11,17,20,0.82), rgba(11,17,20,0.82)),
                   linear-gradient(160deg, rgba(56,106,122,0.07) 0%, rgba(11,17,20,0.10) 100%),
                   url(${trailBackgroundUrl}),
                   linear-gradient(150deg, #0b1114 20%, #0f171b 100%)`
                : `linear-gradient(rgba(255,255,255,0.92), rgba(255,255,255,0.92)),
                   linear-gradient(160deg, rgba(6,178,207,0.06) 0%, rgba(119,141,147,0.035) 100%),
                   url(${trailBackgroundUrl}),
                   linear-gradient(150deg, #f9f6f2ff 20%, #ffffff 100%),
                   url(${traLogoUrl})`,
            backgroundPosition:
              mode === "dark"
                ? "center top, center top, center center, center top"
                : "center top, center top, center center, center top, right 32px top 24px",
            backgroundRepeat:
              mode === "dark" ? "no-repeat, no-repeat, repeat, no-repeat" : "no-repeat, no-repeat, repeat, no-repeat, no-repeat",
            backgroundSize:
              mode === "dark" ? "cover, cover, 760px auto, cover" : "cover, cover, 480px auto, cover, 160px",
            backgroundAttachment: "fixed",
          },
          "#root": {
            minHeight: "100vh",
          },
        },
      },
    },
  });
